import SectionHeading from "@/pages/home/components/SectionHeading";
import { changeReasons } from "@/mocks/siteData";

export default function AddressChange() {
  return (
    <section id="changes" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="Why Address Changes"
              title="地址为什么会变化"
              desc="理解地址变动的原因，能让你在遇到访问异常时更从容，而不是急着怀疑自己操作错了。"
            />
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
              地址变动并不代表平台“消失”了。多数情况下，它只是运营层面的正常调整。认清常见原因之后，你会发现真正需要做的，往往只是更新一下书签或换一条线路。
            </p>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {changeReasons.map((reason, index) => (
              <div
                key={reason.title}
                className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200"
              >
                <div className="flex flex-col items-center">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 font-label text-sm font-medium shrink-0">
                    {index + 1}
                  </span>
                  {index < changeReasons.length - 1 && (
                    <span className="w-px flex-1 bg-background-200 mt-2" aria-hidden="true" />
                  )}
                </div>
                <div className="pb-1">
                  <h3 className="text-base font-heading font-bold text-foreground-950">
                    {reason.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}